import { NavListItem } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdContentCopy, MdOutlineDescription, MdUpload } from "react-icons/md";
import { NavLink } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  return (
    <Layout
      {...props}
      marketplaceElements={
        <Fragment>
          <NavLink to="/admin/platform/newsrpm-marketplace/network">
            <NavListItem icon={MdUpload}>Networks</NavListItem>
          </NavLink>
          <NavLink to="/admin/platform/newsrpm-marketplace/site">
            <NavListItem icon={MdOutlineDescription}>Sites</NavListItem>
          </NavLink>
          <NavLink to="/admin/platform/newsrpm-marketplace/instance">
            <NavListItem icon={MdContentCopy}>Instances</NavListItem>
          </NavLink>
        </Fragment>
      }
    />
  );
}
